// extracted by mini-css-extract-plugin
export default {"root":"_13CUP","text-block":"YvxWw","textBlock":"YvxWw","prefix":"_3Fmtt"};